<script>
  import LogoIcon from "./icons/LogoIcon.svelte";


</script>

<style>
  .toolbar {
    display: flex;
    align-items: center;
    height: 70px;
  }
  .logo {
    width: 40px;
    margin-right: 10px;
    display: contents;
  }
</style>

<div class='toolbar'>
  <h1 class="logo"><LogoIcon />Talking Stickies</h1>
</div>
